import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ServiceOrderReport } from './serviceOrderReport';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Customer } from 'src/app/options/customer.model';
import { MainService } from '../../mainservices/mainservices.model';
import { ServiceordersreportsService } from '../serviceordersreports.service';
import { MandoobService } from 'src/app/options/mandoobs/mandoob.service';
import { MainserviceService } from '../../mainservices/mainservice.service';
import { Globle } from 'src/assets/globle';

@Component({
  selector: 'app-servicesbymandoob',
  templateUrl: './servicesbymandoob.component.html',
  styleUrls: ['./servicesbymandoob.component.css']
})
export class ServicesbymandoobComponent implements OnInit {

  reports: ServiceOrderReport[] = [];
  displayedColumns: string[] = ['orderId', 'dateTime', 'userName', 'serviceName', 'costPrice',
    'price', "amount", "fees"];
  dataSource!: MatTableDataSource<ServiceOrderReport>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  mandoobs: Customer[] = [];
  spinnerOverlay = false;
  selectedMandoob!: string;
  //   lang = 'en';
  //   reportObj: MandoobStatment = {} as MandoobStatment;
  pageSize = 10;
  mainService: MainService[] = [];
  selectedMainService: number = 0;
  constructor(private service: ServiceordersreportsService,
    private mandoobService: MandoobService,
    private mainServiceService: MainserviceService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getManddobs();
    this.getMainService();
  }

  getMainService() {
    this.mainServiceService.getAll(true).subscribe(data => {
      this.mainService = data
    }, error => {
      console.log(error)
    })
  }

  changeTableColumn() {
    var _mainService = this.mainService.find(x => x.id == this.selectedMainService)
    if (_mainService?.type == 1) {
      this.displayedColumns = ['orderId', 'dateTime', 'userName', 'serviceName', 'costPrice', 'price'];
    }
    else if (_mainService?.type == 2) {
      this.displayedColumns = ['orderId', 'dateTime', 'userName', 'serviceName', "amount", "fees"];
    }
    else {
      this.displayedColumns = ['orderId', 'dateTime', 'userName', 'serviceName', 'costPrice',
        'price', "amount", "fees"];
    }
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
    }, error => {
      console.log(error)
    })
  }


  get() {
    this.changeTableColumn()
    this.spinnerOverlay = true;
    this.service.get(this.selectedMandoob, this.selectedMainService,
      this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {
        let obj = data
        this.reports = data;
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          this.spinnerOverlay = false;
          console.log(error);
          this.reports = [];
          this.dataSource = new MatTableDataSource(this.reports);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        })
  }

  getTotalCostPrice() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].costPrice;
      }
    }
    return total;
  }

  getTotalPrice() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].price;
      }
    }
    return total;
  }

  getTotalAmount() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].amount;
      }
    }
    return total;
  }

  getTotalFees() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].fees;
      }
    }
    return total;
  }

  getProfit() {
    var total = 0;
    for (var i = 0; i < this.reports.length; i++) {
      if (this.reports[i].status != 2) {
        total += this.reports[i].mainServiceType == 1 ?
          this.reports[i].price - this.reports[i].costPrice :
          this.reports[i].fees
      }
    }
    return total;
  }

  onApply() {
    this.get();
  }

  //   getTotalCost() {
  //     return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  //   }

  //   getProfits() {
  //     var costPric = 0;
  //     var total = 0;
  //     for (var i = 0; i < this.reports.length; i++) {
  //       costPric += this.reports[i].productCostPrice * this.reports[i].quantity;
  //       total += this.reports[i].total;
  //     }
  //     var profit = total - costPric;
  //     return profit.toFixed(3);

  //     // return this.reports.map(t => t.total - t.productCostPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  //   }

  //   Print() {

  //     const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

  //     doc.addFileToVFS("../../assets/Amiri/Amiri-Regular.ttf", this.globle.AmiriRegular);
  //     doc.addFont("../../assets/Amiri/Amiri-Regular.ttf", "Amiri", "normal");

  //     doc.setFont("Amiri");

  //     doc.setFontSize(18);
  //     doc.setTextColor(40);
  //     //doc.setFont("",'normal');

  //     doc.text("كشف مندوب ", 90, 10);
  //     doc.text("_________________________________", 50, 12);

  //     // set font
  //     doc.setFontSize(10);
  //     doc.viewerPreferences({ "Direction": "L2R" }, true);
  //     doc.text(" المندوب : " + this.mandoobs.find(x => x.id == this.selectedMandoob)?.fullName, 150, 20, {
  //       isOutputRtl: true,

  //     });

  //     if (this.fromDate.nativeElement.value != null && this.fromDate.nativeElement.value != ""
  //       && this.toDate.nativeElement.value != null && this.toDate.nativeElement.value != "") {
  //       doc.text(" من تاريخ : " + this.fromDate.nativeElement.value, 100, 20, {
  //         isOutputRtl: true
  //       });
  //       doc.text(" الى تاريخ : " + this.toDate.nativeElement.value, 50, 20, {
  //         isOutputRtl: true
  //       });
  //     }



  //     //autoTable({ html: '#orderProductTable', margin: { top: 30 }, styles: { font: "Amiri" } });
  //     autoTable(doc, { html: '#mandoobTable', margin: { top: 30 }, styles: { font: "Amiri" } });
  //     //doc.save("test.pdf");
  //     doc.output('dataurlnewwindow');
  //   }


}
